export default __webpack_public_path__ + "static/media/sounds/ran_numbers_seven_alyx.mp3";